// Vocabulaire de l'oncologie, partagé par le serveur et l'interface : la
// reconnaissance du type de dossier et la carte « Cancer » doivent s'accorder
// sur ce qui est un diagnostic de cancer.
const MOTS = /cancer|carcinom|adenocarcinom|tumeur|tumoral|neoplas|sarcom|lymphom|metastas|myelom|leucemi|melanom|blastom|dysplasie de haut grade|cin ?3|lesion maligne|malignite/;
function sansAccent(texte) {
    return texte
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/œ/g, 'oe')
        .toLowerCase();
}
/** Ce libellé désigne-t-il une maladie cancéreuse ? */
export function estOncologique(libelle) {
    if (!libelle)
        return false;
    return MOTS.test(sansAccent(libelle));
}
/**
 * Les champs d'oncologie que le médecin remplit le plus souvent. Ce sont des
 * suggestions, pas des champs imposés : le cahier des charges demande de ne
 * rien figer tant que ce n'est pas précisé, et la saisie reste libre.
 */
export const CHAMPS_ONCOLOGIE = [
    'Histologie',
    'Localisation',
    'Stade',
    'TNM',
    'Grade',
    'Récepteurs hormonaux',
    'HER2',
    'Ki-67',
    'Statut BRCA',
    'Mutation',
    'Marqueur suivi',
    'Décision de RCP',
];
/** L'ordre dans lequel ces champs se lisent sur la carte « Cancer ». */
export function rangChampOncologie(libelle) {
    const index = CHAMPS_ONCOLOGIE.findIndex((champ) => sansAccent(champ) === sansAccent(libelle));
    return index === -1 ? CHAMPS_ONCOLOGIE.length : index;
}
//# sourceMappingURL=oncologie.js.map